import type { FaireProductEntity } from "../../entity_types/product";

export const p_89w2pzqvk2: FaireProductEntity = {
  token: "p_89w2pzqvk2",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Oxide",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/228860bd5b2cd88026d10b3650e138d3868661f7e40210ee27393a5a6de59098.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ebe8898c10445333733b00bd08ab97984a21f1f50e3c163f74803419c2935ca.jpeg",
    "https://cdn.faire.com/fastly/9025cdca2fd4814bd5f2f0e28e65b307ff67625f28dc540faf4cbba23cef64c0.jpeg",
    "https://cdn.faire.com/fastly/b7ec23d5c4d281e0d2154cdd8482aa26020d9dda408383b0ee1bf214c773897f.jpeg",
    "https://cdn.faire.com/fastly/0f9621b189b6ab2c5f279e4f85d3a117558110c6b940128f973abc735ce69cea.jpeg",
    "https://cdn.faire.com/fastly/bc2c02d2a52529f1a46d16efaeece1e789be9a92c21f54985e47e157ad5d5705.jpeg",
    "https://cdn.faire.com/fastly/6cc131c001e74c002f087e31f054f6356283b328a821ea7096da68061956323b.jpeg",
    "https://cdn.faire.com/fastly/900dbf7d16207e15f652a18e10a3c4568ed523e92631923cc2a57becbe859ed5.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee, built on a bold jacquard grid — the pattern is knitted in, never printed on top. Lightweight, breathable, and easy to style.\n\n * Slightly cropped and boxy body \n * 100% Pima cotton \n * Made in Lima, Peru, with knitwear specialists we have worked with for years — Fair Trade certified ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:21.991Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
